// extracted by mini-css-extract-plugin
export default {"modalTitle":"DeleteBranch_modalTitle__nsQmj","branchTitle":"DeleteBranch_branchTitle__xmeaM"};